export default "__VITE_ASSET__9Aw_A0Bt__"